import { createFileRoute } from '@tanstack/react-router';
import UserList from '~/containers/UserList';

export const Route = createFileRoute('/users/')({
  component: UserList,
  validateSearch(search) {
    return {
      search: (search.search as string) || undefined,
      page: search.page !== undefined ? Number(search.page) : undefined,
      congregation: (search.congregation as string) || undefined,
      role: search.role as string | string[] | undefined,
      state: (search.state as string) || undefined,
      pioneerLevel: (search.pioneerLevel as string) || undefined,
      privilege: (search.privilege as string) || undefined,
      experienceLevel: (search.experienceLevel as string) || undefined,
    };
  },
});
